module.exports = __webpack_public_path__ + "img/LKS_mouth.1d91ea23.jpg";